import * as Actions from '../actions/actions'
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';

export default class Mutators {
    constructor(settings) {
        this._settings = settings;

        try {
            this._$ = require('jquery').noConflict(true);
            require('jquery-ui/ui/widgets/resizable');
        } catch (e) {
            console.error(`ResizeWindow.Mutators error: ${e}`);
        }
    }

    initialize(store) {
        this._store = store;
        this._state = store.getState();
    }

    getMutate() {
        return (parameters) => {
            let $ = this._$;

            this._resizeOptions = {};

            let ResizeHook = function(){};
            ResizeHook.prototype.hook = (node, propertyName, previousValue) => {
                this._resizeOptions = {
                    cancel: `.${this._settings.classNames.launchPointContainer}`,
                    containment: 'document',
                    disableSelection: false,
                    maxHeight: 10000,
                    maxWidth: 10000,
                    minHeight: 400,
                    minWidth: 350,
                    handles: 'all',
                    alsoResize: '.also-resize',
                    iframeFix: true,
                    start: onStart,
                    resize: onResize,
                    stop: onEnd
                };

                let optionsFromSettings = this._settings.Resize || {};
                this._resizeOptions = Object.assign(this._resizeOptions, optionsFromSettings);

                let $resizableElement = $(`.${this._settings.classNames.windowClassName}`);
                // Check whether element exists and whether
                // draggable has already been set up.
                if (!$resizableElement ||
                        !$resizableElement[0] ||
                        getComputedStyle($resizableElement[0]).position === 'static' ||
                        $resizableElement.hasClass('ui-resizable')
                )
                    return;

                try {
                    $resizableElement.resizable('option', 'disabled'); // Throws if not inited
                    $resizableElement.resizable('destroy'); // Won't hit if thrown already
                } catch (e) {
                }

                $resizableElement.resizable(this._resizeOptions);
                $resizableElement.resizable('enable');
            };

            let onStart = (event, ui) => {
                // iframe fix
                if (this._resizeOptions.iframeFix) {
                    this._iframes = $('iframe').map(function() {
                        let $iframe = $(this);

                        return $('<div>')
                            .css('position', 'absolute')
                            .appendTo($iframe.parent())
                            .outerWidth($iframe.outerWidth())
                            .outerHeight($iframe.outerHeight())
                            .offset($iframe.offset())[0];
                    });
                }

                // update the state
                let isResizingStateLoc = this._settings.stateLocations.Window.isResizing;
                this._store.dispatch(Actions.startResizeWindow(isResizingStateLoc));
            };

            let onResize = (event, ui) => {
                document.querySelectorAll(`.${this._settings.classNames.windowClassName} iframe + div`).forEach((div) => {
                    let $iframe = $(div.previousSibling);
                    let $div = $(div);

                    $div.outerWidth($iframe.outerWidth());
                    $div.outerHeight($iframe.outerHeight());
                });
            };

            let onEnd = (event, ui) => {
                // remove iframe fix
                if (this._iframes) {
                    this._iframes.remove();
                    delete this._iframes;
                }

                let transformedPos = {
                    xPos: ui.position.left,
                    yPos: ui.position.top
                };

                let curSize = {
                    width: `${ui.size.width}px`,
                    height: `${ui.size.height}px`
                };

                let sizeStateLoc = this._settings.stateLocations.Window.size;
                let isResizingStateLoc = this._settings.stateLocations.Window.isResizing;
                let positionLocation = this._settings.stateLocations.Window.position;

                this._store.dispatch(Actions.endResizeWindow(
                    isResizingStateLoc,
                    sizeStateLoc,
                    curSize,
                    positionLocation,
                    transformedPos));
                
                const input = {
                    eventName: 'UserResizedIVA',
                    eventValue: true,
                    messageType: this._settings.messageConstants.reportingEventRequest,
                };
                sendRequest(input);
            };

            let resizeBehavior = {
                resize: new ResizeHook()
            };

            return Object.assign({}, parameters, resizeBehavior);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-resize/src/renderers/mutator.js